import React from 'react';

import "./Assignment.css";

import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function Assignment(props) {

  let navigate = useNavigate();

  function getAssignmentPageLink() {
    if (props.assignment.template_id === -1) return "/group_formation"
    if (props.assignment.template_id === -3) return "/projects"
    return "/responses";
  }

  return (
    <Grid container spacing={1} sx={{m: 0}} className="assignment-card" onClick={() => navigate(getAssignmentPageLink(), { state: {...props.state, assignment: props.assignment}})}>
      <Grid item xs={12}>
        <Typography sx={{fontSize: "18px"}}>{props.assignment.name}</Typography>
      </Grid>
      {
        props.assignment.template_id === -1 ?
        <Grid item xs={12}>
          <Typography sx={{fontSize: "16px"}}>Results for this assignment can be found on the group formation page</Typography>
        </Grid>
        : props.assignment.template_id === -3 ?
        <Grid item xs={12}>
          <Typography sx={{fontSize: "16px"}}>Results for this assignment can be found on the public projects page</Typography>
        </Grid>
        : null
      }
      <Grid item xs={6}>
        <Typography>{"Start: " + props.assignment.start}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography>{"End: " + props.assignment.end}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>{"# of Questions: " + props.assignment.questions.length}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>{"# of Submissions: " + (props.assignment.questions[0]?.responses.length || 0)}</Typography>
      </Grid>
    </Grid>
  )
}

export default Assignment;